/* eslint-disable */
import store from '@/vuex/store';

export default class MockAuthService {
  constructor() {
    this.loginLevel4 = this.loginLevel4.bind(this);
    this.logout = this.logout.bind(this);
    this.updateToken = this.updateToken.bind(this);

    this.keycloak = {
      token: 'mockKeycloakAccessToken',
    };
  }

  async init() {
    await store.dispatch('setLoginLevel4Function', this.loginLevel4);
    await store.dispatch('setBrukerinfo', {
      brukerId: '02026600114',
      fornavn: 'Birger Fos',
      etternavn: 'Saus',
      sikkerhetsniva: 3,
      email: '24076900147-test@minid.norge.no',
    });
    await store.dispatch('representasjoner/getRepresentations');
    await store.dispatch('setAuthenticated', true);
    return new Promise((resolve) => resolve(true));
  }

  loginLevel4() {
    store.dispatch('setBrukerinfo', {
      brukerId: '02026600114',
      fornavn: 'Birger Fos',
      etternavn: 'Saus',
      sikkerhetsniva: 4,
      email: '24076900147-test@minid.norge.no',
    });
    store.dispatch('representasjoner/getRepresentations');
    store.dispatch('setAuthenticated', true);
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
  }

  updateToken() {
    return new Promise((resolve) => resolve(true));
  }
}
